import { render, staticRenderFns } from "./interviewCardItem.vue?vue&type=template&id=180b8639&scoped=true"
import script from "./interviewCardItem.vue?vue&type=script&lang=js"
export * from "./interviewCardItem.vue?vue&type=script&lang=js"
import style0 from "./interviewCardItem.vue?vue&type=style&index=0&id=180b8639&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180b8639",
  null
  
)

export default component.exports